import React from 'react';
import ReactDOM from 'react-dom/client';

import './assets/themes/global.css';     // Глобальные стили
import './assets/themes/light-theme.css'; // Стили для светлой темы
import './assets/themes/dark-theme.css';  // Стили для темной темы

import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);
